/**
 * Object Metier CRT
 */
export interface ObjetMetier {
  /**
   * Type de l'objet métier
   */
  type: ObjetMetierTypeEnum;
  /**
   * identifiant
   */
  id: number;
  /**
   * date d'actualisation du métier
   */
  actualisation: Date;
  /**
   * descriptions des niveaux hierarchique
   */
  descriptionHierarNiv1: string;
  descriptionHierarNiv2: string;
  descriptionHierarNiv3: string;
  identifiantOh: number;
  idHierarNiv1: number;
  idHierarNiv2: number;
  idHierarNiv3: number;
  /**
   * description métier
   */
  descriptionMetier: string;
  /**
   * libelle site
   */
  libelleSite: string;
  /**
   * dkcode site
   */
  dkCodeSite: string;
  /**
   * libelle installation
   */
  libelleInstallation: string;
  /**
   * dkcode installation
   */
  dkCodeInstallation: string;
  /**
   * priorité du métier
   */
  priorite: number;
  /**
   * etat de concordance du métier (false si le métier est discordant)
   */
  etatConcordance: boolean;
  /**
   * maintenance
   */
  maintenance: boolean;
  /**
   * blocage
   */
  blocage: boolean;
  /**
   * invalidation
   */
  invalidation: boolean;
  /**
   * presence personnel
   */
  presencePersonnel: number;
  /**
   * Statut de l'objet
   */
  statut: ObjetMetierStatut;

  idSdd: number;

  etatEnvoi: number;

  readonly?: boolean;
  /**
   * Etat fonctionnel du objet métier
   */
  etatFonctionnel: string;
}
/**
 * Enum qui représente les statuts possible
 */
export enum ObjetMetierStatut {
  /**
   * Objet métier à configurer
   */
  CONFIG = 'A configurer',
  /**
   * Objet métier à envoyer
   */
  ENVOI = 'A envoyer',
  /**
   * vide
   */
  VIDE = '',
}

export enum ObjetMetierTypeEnum {
  /**
   * Programme horaire
   */
  PH,
  /**
   * Loi régulation
   */
  LR,
}
